import { render, staticRenderFns } from "./RejectInspect.vue?vue&type=template&id=081cb95c&scoped=true"
import script from "./RejectInspect.vue?vue&type=script&lang=ts"
export * from "./RejectInspect.vue?vue&type=script&lang=ts"
import style0 from "./RejectInspect.vue?vue&type=style&index=0&id=081cb95c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081cb95c",
  null
  
)

export default component.exports